<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Rezeptinformationen</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-col class="col-12">
                    <v-select
                            :items="kindOfForms"
                            label="Backform auswählen"
                            v-model="postItem.form_factor"
                    ></v-select>

                    <v-select
                            :items="kindOfPiece"
                            label="Stück/Durchmesser/Person"
                            v-model="postItem.recipe_type"
                    ></v-select>
                </v-col>
                <v-col class="col-12">
                    <v-slider
                            v-model="postItem.count_diameter_pieces"
                            class="align-center"
                            :max="maxPieces"
                            :min="minPieces"
                            label="Anzahl / Durchmesser / Stück"
                            hide-details
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="postItem.count_diameter_pieces"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 60px"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col class="col-4">
                    <v-text-field
                            v-model="postItem.form_width"
                            label="Formbreite"
                            required
                    ></v-text-field>
                </v-col>
                <v-col class="col-4">
                    <v-text-field
                            v-model="postItem.form_height"
                            label="Formhöhe"
                            required
                    ></v-text-field>
                </v-col>
                <v-col class="col-4">
                    <v-text-field
                            v-model="postItem.form_length"
                            label="Formlänge"
                            required
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  export default {
    name: 'PostRecipeInformationComponent',
    props:['postItem'],
    data: () => {
      return {
        maxPieces: 500,
        minPieces: 0,
        kindOfForms: [
          {text:'keine Form', value:'', selected:false},
          {text:'eckig', value:'eckig', selected:false},
          {text:'rund', value:'rund', selected:false}
        ],
        kindOfPiece:[
          {text:'kein Wert', value:'', selected:false},
          {text:'Durchmesser', value:'Durchmesser', selected:false},
          {text:'Person',value:'Person', selected:false},
          {text:'Stück',value:'Stück', selected:false}
        ]
      }
    }
  }
</script>

<style scoped>

</style>